import { Injectable } from '@angular/core';

import { Association } from '@shared/models';

import { Note, NoteSubject } from 'mojo-irp-notes';

@Injectable()
export class NoteFactory {
  create(
    association: Association,
    subjectType: NoteSubject,
    category?: string,
    subCategory?: string,
  ): Note {
    return {
      subjectId: association.id,
      category: !!category ? category : association.status,
      subCategory: !!subCategory ? subCategory : association.subStatus,
      subjectType,
      content: association.noteComment,
      systemGenerated: true,
      isPublic: true,
    };
  }
}
